import React, { useState } from 'react'
import { Button } from '@material-ui/core';

const EditUsername = ({socket, onClose, onUpdateCookie}) => {

    const [username, setUsername] = useState('')

    const updateUsername = () => {
        if (socket != null) {
            onUpdateCookie(username);
            socket.emit('updateUsername', username);
            setUsername('');
            onClose();
        }
    }

    return (
        <>
            <div className='EditUsername'>
                <h3>Set Your Username</h3>
                <input type={'text'} className='TextField' placeholder="Username" size="small" variant='filled' value={username} autoComplete="off" onKeyPress={(e)=>{
                    if(e.code == 'Enter') {
                        updateUsername();
                    }
                }} onChange={(e)=>{
                    if(e.target.value.length < 51) setUsername(e.target.value);
                }}/>
                <div id='edit-buttons'>
                    <Button className='ui-button' style={{backgroundColor: '#D20000'}} variant="contained" color='secondary' disableElevation onClick={onClose}>Cancel</Button>
                    <Button className='ui-button' style={{backgroundColor: '#D20000'}} variant="contained" color='secondary' disableElevation onClick={updateUsername}>Set</Button>
                </div>
            </div>
        </>

    )
}

export default EditUsername;